import { Grid, IconButton, Popover, Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { useSelector } from "react-redux";

export default function Disclaimer(props) {
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const { open, setOpen } = props;
  const t = props.t;

  return (
    <div>
      <Popover
        open={open}
        PaperProps={{
          style: {
            position: "relative",
            width: isDesktopOrLaptop ? "757px" : "100%",
            borderRadius: "15px",
            justifySelf: "center",
            marginTop: isDesktopOrLaptop ? "25vh" : 0,
            marginLeft: isDesktopOrLaptop ? "auto" : 0,
            marginRight: isDesktopOrLaptop ? "auto" : 0,
            zIndex: 10010,
            backgroundColor: "#fff",
          },
        }}
        BackdropProps={{ style: { backgroundColor: "#000", opacity: 0.81 } }}
      >
        <Grid container justifyContent="flex-end">
          <IconButton
            onClick={() => {
              setOpen(false);
            }}
          >
            <Close style={{ color: "#808080" }} />
          </IconButton>
        </Grid>
        <Grid
          style={{
            padding: isDesktopOrLaptop
              ? "39px 87px 87px 87px"
              : "17px 20px 69px 15px",
          }}
        >
          <Typography
            style={{
              fontFamily: "Overpass",
              fontSize: isDesktopOrLaptop ? "32px" : "26px",
              fontWeight: "bold",
              lineHeight: 1.22,
              color: "#16063b",
            }}
          >
            {t("disclaimer_title")}
          </Typography>
          <Typography
            style={{
              fontFamily: "Overpass",
              fontSize: "16px",
              lineHeight: 1.5,
              color: "#808080",
              marginTop: "26px",
            }}
          >
            {t("disclaimer_detail")}
          </Typography>
        </Grid>
      </Popover>
    </div>
  );
}
